import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { memo, useMemo } from 'react';
import SliderDot from '@dtvgo/slider-dot';
import { getNormalizedPercentageFromValue, percentageToCSSValue } from '@dtvgo/utils';
import { useSliderConfig } from './SliderContext.js';
import { SliderClassNames } from './utils.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

function DotTemplate(_ref) {
  var className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    value = _ref.value;
  var _useSliderConfig = useSliderConfig(),
    vertical = _useSliderConfig.vertical,
    maxValue = _useSliderConfig.maxValue,
    minValue = _useSliderConfig.minValue;
  var valuePercentage = getNormalizedPercentageFromValue(value, maxValue, minValue);
  var dotCssProperty = vertical ? 'bottom' : 'left';
  var dotStyle = useMemo(function () {
    return _objectSpread(_objectSpread({}, style), {}, _defineProperty({}, dotCssProperty, "".concat(percentageToCSSValue(valuePercentage))));
  }, [dotCssProperty, style, valuePercentage]);
  return /*#__PURE__*/jsx(SliderDot, {
    className: SliderClassNames.element('dot', className),
    style: dotStyle,
    children: children
  });
}
DotTemplate.defaultProps = {
  className: '',
  style: {},
  children: null
};
var DotTemplate$1 = /*#__PURE__*/memo(DotTemplate);

export { DotTemplate$1 as default };
//# sourceMappingURL=DotTemplate.js.map
